export default (image, aspect = image.width / image.height) => {
  let src = image.src ?? image.url;
  const size = Shopify.Image.imageSize(src);
  if (size) {
    src = src.replace(`_${size}`, '');
  }

  return `
  <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
     data-src="${Shopify.Image.getSizedImageUrl(src, '{width}x{height}_crop_center')}"
     data-aspectratio="${aspect}"
     data-sizes="auto"
     data-max-width="${image.width}"
     data-max-height="${image.height}"
     alt="${image.alt ?? ''}"
     class="lazyload">
  `;
};
